// Crystal-ball oracle - standalone per-route bundle, no Stimulus.
//
// Built as its own IIFE entry point (see package.json) and loaded only on
// /kristallkugel-online via `javascript_include_tag "kristallkugel"`, so the
// ported mini-apps never bloat the global bundle or touch the Stimulus
// registry (avoids the cross-bundle Stimulus breakage from 2026-06-08).
//
// Turbo-safe: a per-element guard makes init idempotent, and the turbo:load
// listener is registered once at window scope so repeat visits don't stack
// listeners.
(function () {
  var CONJURE_MS = 1600;

  function init() {
    var root = document.querySelector("[data-crystal-ball]");
    if (!root || root.dataset.cbBooted) return;

    var signs;
    try {
      signs = JSON.parse(root.dataset.signs || "[]");
    } catch (e) {
      return;
    }
    if (!signs.length) return;

    var ball = root.querySelector("[data-crystal-ball-ball]");
    var symbol = root.querySelector("[data-crystal-ball-symbol]");
    if (!ball || !symbol) return;

    root.dataset.cbBooted = "1";

    var result = root.querySelector("[data-crystal-ball-result]");
    var nameEl = root.querySelector("[data-crystal-ball-name]");
    var textEl = root.querySelector("[data-crystal-ball-interpretation]");
    var hint = root.querySelector("[data-crystal-ball-hint]");
    var resetButton = root.querySelector("[data-crystal-ball-reset]");

    var busy = false;
    var revealed = false;

    function randomSign() {
      return signs[Math.floor(Math.random() * signs.length)];
    }

    function draw() {
      if (busy || revealed) return;
      busy = true;
      ball.classList.add("is-conjuring");
      if (hint) hint.classList.add("opacity-0");
      setTimeout(function () {
        reveal(randomSign());
      }, CONJURE_MS);
    }

    function reveal(sign) {
      symbol.src = sign.image;
      symbol.alt = sign.name;
      ball.classList.remove("is-conjuring");
      ball.classList.add("is-revealed");
      if (nameEl) nameEl.textContent = sign.name;
      if (textEl) textEl.textContent = sign.interpretation;
      if (result) {
        result.classList.remove("hidden");
        result.classList.add("fade-in");
      }
      if (resetButton) resetButton.classList.remove("hidden");
      revealed = true;
      busy = false;
    }

    function reset() {
      if (busy) return;
      ball.classList.remove("is-revealed", "is-conjuring");
      if (result) {
        result.classList.add("hidden");
        result.classList.remove("fade-in");
      }
      if (resetButton) resetButton.classList.add("hidden");
      symbol.removeAttribute("src");
      symbol.alt = "";
      if (hint) hint.classList.remove("opacity-0");
      revealed = false;
    }

    ball.addEventListener("click", draw);
    if (resetButton) resetButton.addEventListener("click", reset);
  }

  if (!window.__crystalBallBooted) {
    window.__crystalBallBooted = true;
    document.addEventListener("turbo:load", init);
  }

  init();
})();
